import { useTranslations } from '@vocab/react';
import type React from 'react';

import translations from './.vocab';

interface Props {
  jobStatus: { isExpired: boolean; isPending: boolean };
  jobTitle: string;
}

export const JobTitleHeadingContent: React.FC<Props> = ({
  jobStatus,
  jobTitle,
}) => {
  const { t } = useTranslations(translations);
  const { isExpired, isPending } = jobStatus;

  if (isExpired) {
    return <>{t('Expired:', { title: jobTitle })}</>;
  }

  if (isPending) {
    return <>{t('Pending:', { title: jobTitle })}</>;
  }

  return <>{jobTitle}</>;
};
